<div class="ratings-component">
  <div class="stars" *ngIf="showIfEmpty || (rating || 0) > 0">
    <ng-container
      *ngFor="let star of getStars(); let pos = index; trackBy: trackByRating">
      <popsy-icon-star-filled
        class="icon"
        [class.condensed]="condensed"
        [class.interactive]="mode === 'interactive'"
        [class.full]="star === 'full'"
        [class.empty]="star === 'empty'"
        [class.half]="star === 'half'"
        (click)="onSelectRating(pos + 1)"></popsy-icon-star-filled>
      <span
        *ngIf="mode === 'interactive'"
        class="fixed-space-8"
        aria-hidden="true"></span>
    </ng-container>
    <strong class="text" *ngIf="showStarsCount">({{ roundedRating }})</strong>
  </div>
</div>
